import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#a)" }, [
      _createElementVNode("path", {
        fill: "currentColor",
        d: "M9.73 9.635a2.76 2.76 0 0 1-3.46 0 .734.734 0 0 0-.94 1.13 4.165 4.165 0 0 0 5.34 0 .734.734 0 1 0-.94-1.13M5.8 7.267a.733.733 0 1 0 0-1.467.733.733 0 0 0 0 1.467M10.2 5.8a.733.733 0 1 0 0 1.467.733.733 0 0 0 0-1.467M8 .667a7.333 7.333 0 1 0 0 14.666A7.333 7.333 0 0 0 8 .667m0 13.2A5.866 5.866 0 1 1 8 2.134a5.866 5.866 0 0 1 0 11.733"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "a" }, [
        _createElementVNode("path", {
          fill: "currentColor",
          d: "M0 0h16v16H0z"
        })
      ])
    ], -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })